import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/magic_man_plumbing_heating_calgary.png';

const Navbar = () => {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const isActive = (path) => {
        return location.pathname === path ? 'text-primary-blue font-bold' : 'text-text-dark hover:text-primary-blue';
    };

    return (
        <>
            <div className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4">
                <nav className="glass-panel px-6 py-2 flex justify-between items-center w-full">
                    <Link to="/" className="flex items-center">
                        <img src={logo} alt="Magic Man Plumbing & Heating Calgary - 24/7 Emergency Plumber" className="h-20 w-auto" />
                    </Link>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        <Link to="/" className={isActive('/')}>Home</Link>
                        <Link to="/about" className={isActive('/about')}>About</Link>
                        <Link to="/services" className={isActive('/services')}>Services</Link>
                        <Link to="/contact" className={isActive('/contact')}>Contact</Link>
                        <Link to="/contact">
                            <button className="glass-button py-2 px-6 text-sm">
                                Get a Quote
                            </button>
                        </Link>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden text-text-dark p-2"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {isMobileMenuOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </nav>
            </div>

            {/* Mobile Menu Overlay */}
            <div className={`fixed inset-0 z-40 bg-white/95 backdrop-blur-xl transition-transform duration-300 md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <div className="flex flex-col items-center justify-center h-full space-y-8 text-xl">
                    <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className={isActive('/')}>Home</Link>
                    <Link to="/about" onClick={() => setIsMobileMenuOpen(false)} className={isActive('/about')}>About</Link>
                    <Link to="/services" onClick={() => setIsMobileMenuOpen(false)} className={isActive('/services')}>Services</Link>
                    <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className={isActive('/contact')}>Contact</Link>
                    <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                        <button className="glass-button">
                            Get a Quote
                        </button>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default Navbar;
